var crosspointCustomerFormId = '#RegisterForm'; 

illiJq(function () {

  

  

  illiJq(":input").blur(function () {
    var value = illiJq(this).val();
    if (value && illiJq.type(value) == "string") {
      var replacedValue = value.replace(/｡|ﾟ|№|℡|\\|Ⅰ|Ⅱ|Ⅲ|Ⅳ|Ⅴ|Ⅵ|Ⅶ|Ⅷ|Ⅸ|Ⅹ|ⅰ|ⅱ|ⅲ|ⅳ|ⅴ|ⅵ|ⅶ|ⅷ|ⅸ|ⅹ|∑|√|∟|∠|∥|∩|∪|∫|∮|∵|≒|≡|⊥|⊿|①|②|③|④|⑤|⑥|⑦|⑧|⑨|⑩|⑪|⑫|⑬|⑭|⑮|⑯|⑰|⑱|⑲|⑳|〝|〟|㈱|㈲|㈹|㊤|㊥|㊦|㊧|㊨|㌃|㌍|㌔|㌘|㌢|㌣|㌦|㌧|㌫|㌶|㌻|㍉|㍊|㍍|㍑|㍗|㍻|㍼|㍽|㍾|㎎|㎏|㎜|㎝|㎞|㎡|㏄|㏍|丨|¬|纊|褜|鍈|銈|蓜|俉|炻|昱|棈|鋹|曻|彅|仡|仼|伀|伃|伹|佖|侒|侊|侚|侔|俍|偀|倢|俿|倞|偆|偰|偂|傔|僴|僘|兊|兤|冝|冾|凬|刕|劜|劦|勀|勛|匀|匇|匤|卲|厓|厲|叝|﨎|咜|咊|咩|哿|喆|坙|坥|垬|埈|埇|﨏|塚|增|墲|夋|奓|奛|奝|奣|妤|妺|孖|寀|甯|寘|寬|尞|岦|岺|峵|崧|嵓|﨑|嵂|嵭|嶸|嶹|巐|弡|弴|彧|德|忞|恝|悅|悊|惞|惕|愠|惲|愑|愷|愰|憘|戓|抦|揵|摠|撝|擎|敎|昀|昕|昻|昉|昮|昞|昤|晥|晗|晙|晴|晳|暙|暠|暲|暿|曺|朎|朗|杦|枻|桒|柀|栁|桄|棏|﨓|楨|﨔|榘|槢|樰|橫|橆|橳|橾|櫢|櫤|毖|氿|汜|沆|汯|泚|洄|涇|浯|涖|涬|淏|淸|淲|淼|渹|湜|渧|渼|溿|澈|澵|濵|瀅|瀇|瀨|炅|炫|焏|焄|煜|煆|煇|凞|燁|燾|犱|犾|猤|猪|獷|玽|珉|珖|珣|珒|琇|珵|琦|琪|琩|琮|瑢|璉|璟|甁|畯|皂|皜|皞|皛|皦|益|睆|劯|砡|硎|硤|硺|礰|礼|神|祥|禔|福|禛|竑|竧|靖|竫|箞|精|絈|絜|綷|綠|緖|繒|罇|羡|羽|茁|荢|荿|菇|菶|葈|蒴|蕓|蕙|蕫|﨟|薰|蘒|﨡|蠇|裵|訒|訷|詹|誧|誾|諟|諸|諶|譓|譿|賰|賴|贒|赶|﨣|軏|﨤|逸|遧|郞|都|鄕|鄧|釚|釗|釞|釭|釮|釤|釥|鈆|鈐|鈊|鈺|鉀|鈼|鉎|鉙|鉑|鈹|鉧|銧|鉷|鉸|鋧|鋗|鋙|鋐|﨧|鋕|鋠|鋓|錥|錡|鋻|﨨|錞|鋿|錝|錂|鍰|鍗|鎤|鏆|鏞|鏸|鐱|鑅|鑈|閒|隆|﨩|隝|隯|霳|霻|靃|靍|靏|靑|靕|顗|顥|飯|飼|餧|館|馞|驎|髙|髜|魵|魲|鮏|鮱|鮻|鰀|鵰|鵫|鶴|鸙|黑|ｱ|ｲ|ｳ|ｴ|ｵ|ｶ|ｷ|ｸ|ｹ|ｺ|ｻ|ｼ|ｽ|ｾ|ｿ|ﾀ|ﾁ|ﾂ|ﾃ|ﾄ|ﾅ|ﾆ|ﾇ|ﾈ|ﾉﾊ|ﾋ|ﾌ|ﾍ|ﾎ|ﾏ|ﾐ|ﾑ|ﾒ|ﾓ|ﾔ|ﾕ|ﾖ|ﾗ|ﾘ|ﾙ|ﾚ|ﾛ|ﾜ|ｦ|ﾝｧ|ｨ|ｩ|ｪ|ｫ|ｬ|ｭ|ｮ|ｯ/g, "");
      illiJq(this).val(replacedValue);
    }
  });

  

  if (location.pathname.match(/\/account\/login/)) {
    

    illiJq('#customer_login').submit(function () {
      var syncEmail = illiJq('#customer\\[email\\]').val();
      syncResult = sysncCustomer(syncEmail);
      return true;

    })
    illiJq('#customer_login .form__submit').on('click', function(event){
      if(illiJq('#customer\\[email\\]').val()){
      var syncEmail = illiJq('#customer\\[email\\]').val();
      syncResult = sysncCustomer(syncEmail);
      return true;
      }
    });

    

        //パスワードリセット予約
         illiJq('#customer\\[recover_email\\]').parent().parent().parent().find('form').submit(function(){
            var recoverEmail = illiJq('#customer\\[recover_email\\]').val();
            reserveResult = reservePwReset(recoverEmail);
            return true;//常にtrue
        })
  }


    

    if(location.pathname.match(/\/account\/reset\//) ){
            //パスワードリセット実行
            illiJq('form').submit(function(){
                if(this.action.indexOf('reset')>0){//リセットフォームのsubmit
                    if(illiJq('input[name="customer\\[password\\]"]').val() ==  illiJq('input[name="customer\\[password_confirmation\\]"]').val()){//同値
                        if(illiJq('#customer\\[password\\]').val().length >= 5 ){
                            excuteResult = excutePwReset(this)
//                            console.log(excuteResult)
                        }else{
                          alert('5文字以上で入力してください');
                          return false;
                        }
                    }else{
                      alert('入力と確認が一致しません');
                      return false;
                    }
                }
                return excuteResult;
            })
    }

  

  if (location.pathname.match(/\/cart/)) {
    

    illiJq(".cart__recap").submit(function () {
      if (illiJq('#coordinationFlag').val() == "cancel") {
        return true;
      }
      var memberId = illiJq('#customerId').val();
      if (!memberId) { 

        return true
      }
      

      var cpMessage = getDisacountByCp()
      if (cpMessage) {
        return true;
      }
      else {
        return false;
      }
    })
  }

  

  if (location.pathname.match(/\/account\/register/)) {
    
    var cardNo = getParam('MEMBER_ID');
    var pinCd = getParam('PIN_CD');
    if(cardNo && pinCd){
      illiJq("#RegisterForm-cardNo").val(cardNo);
      illiJq("#RegisterForm-pinCd").val(pinCd);
    }
    var sexValue = illiJq(`${crosspointCustomerFormId}-sex-update`).val();
    if (sexValue) {
      illiJq('#RegisterForm-sex-3').prop('checked', false);
      illiJq(`#RegisterForm-sex-${sexValue}`).prop('checked', true);
    }
    

    var prefnameValue = illiJq(`${crosspointCustomerFormId}-prefname-update`).val();
    if (prefnameValue != null) {
      illiJq(`${crosspointCustomerFormId}-prefname-list`).val(prefnameValue);
      illiJq(`${crosspointCustomerFormId}-prefname`).val(prefnameValue);
    }
    

    var phoneValue = illiJq(`${crosspointCustomerFormId}-phone-update`).val();
    if (phoneValue != null) {
      replacedPhone = phoneValue.replace('+81', '0')
      illiJq(`${crosspointCustomerFormId}-phone`).val(replacedPhone);
    }
    

    var postcard_dm_unnecessary_flgValue = illiJq(`${crosspointCustomerFormId}-postcard_dm_unnecessary_flg-update`).val();
    if (postcard_dm_unnecessary_flgValue == "1") {
      illiJq('input:checkbox[name="customer[postcard_dm_unnecessary_flg]"]').prop('checked', false);
    }
    

    var accepts_marketingValue = illiJq(`${crosspointCustomerFormId}-accepts_marketing-update`).val();
    if (accepts_marketingValue == "false") {
      illiJq('input:checkbox[name="customer[accepts_marketing]"]').prop('checked', false);
    }
    

    for (var n = 1; n <= 100; n++) {
      var updateCustomAttribute = illiJq(`${crosspointCustomerFormId}-customattribute${n}-update`); 

      

      if (updateCustomAttribute.length) {
        var dataType = updateCustomAttribute.data("type");
        var updateValue = updateCustomAttribute.val();
        

        if (dataType == "select") {
          illiJq(`${crosspointCustomerFormId}-customattribute${n}`).val(updateValue);
        }
        

        else if (dataType == "radio") {
          var attributes = illiJq(`${crosspointCustomerFormId}-customattribute${n}-wrap`).find("input[type=radio]"); 

          attributes.each(function () {
            if (illiJq(this).val() == updateValue) {
              illiJq(this).prop("checked", true);
            }
          });
        }
        

        else if (dataType == "checkbox") {
          var attributes = illiJq(`${crosspointCustomerFormId}-customattribute${n}-wrap`).find("input[type=checkbox]"); 

          attributes.each(function () {
            var inputElement = illiJq(this);
            if (updateValue.indexOf(",") !== -1) { 

              var updateArray = updateValue.split(",");
              for (var element of updateArray) {
                if (inputElement.val() == element) {
                  inputElement.prop("checked", true);
                }
              }
            } else { 

              if (inputElement.val() == updateValue) {
                inputElement.prop("checked", true);
              }
            }
          });
        }
      }
    }
    

    var time = new Date();
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var selectedYear = document.getElementById("year").value;
    var selectedMonth = document.getElementById("month").value;
    for (var i = year; i >= 1900; i--) {
      illiJq('#year').append('<option value="' + i + '">' + i + '</option>');
    }
    for (var j = 1; j <= 12; j++) {
      illiJq('#month').append('<option value="' + j + '">' + j + '</option>');
    }
    for (var k = 1; k <= 31; k++) {
      illiJq('#date').append('<option value="' + k + '">' + k + '</option>');
    }
    illiJq('#year').change(function () {
      selectedYear = illiJq('#year').val();
      var last_month = 12;
      if (selectedYear == year) {
        last_month = month;
      }
      illiJq('#month').children('option').remove();
      illiJq('#month').append('<option value="' + 0 + '"> </option>');
      for (var n = 1; n <= last_month; n++) {
        var nStr = n.toString();
        illiJq('#month').append('<option value="' + nStr + '">' + nStr + '</option>');
      }
    });
    illiJq('#year,#month').change(function () {
      selectedYear = illiJq('#year').val();
      selectedMonth = illiJq('#month').val();
      if (selectedYear == year && selectedMonth == month) {
        var lastDate = date;
      } else {
        

        if (selectedMonth == 2) {
          if ((Math.floor(selectedYear % 4 == 0)) && (Math.floor(selectedYear % 100 != 0)) || (Math.floor(selectedYear % 400 == 0))) {
            lastDate = 29;
          } else {
            lastDate = 28;
          }
          

        } else if (selectedMonth == 4 || selectedMonth == 6 || selectedMonth == 9 || selectedMonth == 11) {
          lastDate = 30;
        } else {
          lastDate = 31;
        }
      }
      illiJq('#date').children('option').remove();
      illiJq('#date').append('<option value="' + 0 + '"> </option>');
      for (var m = 1; m <= lastDate; m++) {
        var mStr = m.toString();
        illiJq('#date').append('<option value="' + mStr + '">' + mStr + '</option>');
      }
    });

    

    illiJq("input[type=checkbox]").click(function () {

      

      var dataLimit = illiJq(this).data("limit");
      var attributeName = illiJq(this).attr('name');
      var checked = illiJq(`input[name='${attributeName}']:checked`);
      if (dataLimit != null) {
        var notChecked = illiJq(`input[name='${attributeName}']`).not(':checked')
        if (checked.length >= parseInt(dataLimit, 10)) {
          notChecked.attr("disabled", true);
        } else {
          notChecked.attr("disabled", false);
        }
      }
      

      if (attributeName != "customer[postcard_dm_unnecessary_flg]") {
        if (attributeName != "customer[accepts_marketing]") {
          var checkedItems = [];
          var attributeData;
          var hiddenName = attributeName.replace("[]", "");
          checked.each(function () {
            checkedItems.push(illiJq(this).val());
            attributeData = checkedItems.join(',');
          });
          document.getElementById(`${hiddenName}-hidden`).value = attributeData;
        }
      }
    });

    

    illiJq("#RegisterForm-submit").click(function submitExcute() {
      

      illiJq(".form__message").each(function () {
        illiJq(this).addClass("hide");
      });
      illiJq(".input--error").each(function () {
        illiJq(this).removeClass("input--error");
      });
      illiJq('#ajax-error-message').addClass("hide");

      

      var error = false;

      

      var passwordMinLength = 5; 

      var passwordValue = illiJq(`${crosspointCustomerFormId}-password`).val();
      if (passwordValue && passwordValue.length < passwordMinLength) {
        illiJq(`${crosspointCustomerFormId}-password`).addClass("input--error");
        illiJq(`${crosspointCustomerFormId}-password-error`).removeClass("hide");
        illiJq(`${crosspointCustomerFormId}-password-error-message`).html(`${String(passwordMinLength)}桁以上で入力してください`);
        error = true;
      }
      

      illiJq(".require").each(function () {
        var value = illiJq(this).val();
        var targetId = illiJq(this).attr('id');
        var errorMessageBlock = `#${targetId}-error`;
        var errorMessage = `#${targetId}-error-message`;
        var dataType = illiJq(this).data("type");
        

        if (dataType == "checkbox" || dataType == "radio") {
          var attributeNameList = targetId.split("-");
          var checkboxId = `${crosspointCustomerFormId}-${attributeNameList[1]}`;
          var attributeName = illiJq(this).attr('name');
          var checkboxErrorMessageLabel = `${checkboxId}-wrap`;
          var checkboxErrorMessageBlock = `${checkboxId}-error`;
          var checkboxErrorMessage = `${checkboxId}-error-message`;
          var checkedItems;
          var dataMinimum = illiJq(this).data("minimum");
          illiJq(this).each(function () {
            checkedItems = illiJq(`input[name='${attributeName}']:checked`).length;
          });
          illiJq(checkboxErrorMessageLabel).removeClass("label--error");
          illiJq(checkboxErrorMessageBlock).addClass("hide");
          if (dataMinimum != null) {
            if (checkedItems < parseInt(dataMinimum, 10)) {
              illiJq(checkboxErrorMessageLabel).addClass("label--error");
              illiJq(checkboxErrorMessageBlock).removeClass("hide");
              illiJq(checkboxErrorMessage).html(dataMinimum + "つ以上選択してください");
              error = true;
            }
          } else if (checkedItems === 0) {
            illiJq(checkboxErrorMessageLabel).addClass("label--error");
            illiJq(checkboxErrorMessageBlock).removeClass("hide");
            illiJq(checkboxErrorMessage).html("1つ以上選択してください");
            error = true;
          }
          

        } else if (dataType == "select") {
          illiJq(this).removeClass("input--error");
          illiJq(errorMessageBlock).addClass("hide");
          if (value == "" || value == "選択してください") {
            illiJq(this).addClass("input--error");
            illiJq(errorMessageBlock).removeClass("hide");
            illiJq(errorMessage).html("必須項目です");
            error = true;
          }
        } else {
          illiJq(this).removeClass("input--error");
          illiJq(errorMessageBlock).addClass("hide");
          if (value == "" || !value.match(/[^\s\t]/)) {
            illiJq(this).addClass("input--error");
            illiJq(errorMessageBlock).removeClass("hide");
            illiJq(errorMessage).html("必須項目です");
            error = true;
          }
        }
      });
      

      illiJq(".date-attribute").each(function () {
        var value = illiJq(this).val();
        var targetId = illiJq(this).attr('id');
        var errorMessageBlock = `#${targetId}-error`;
        var errorMessage = `#${targetId}-error-message`;
        var dataform = illiJq(this).data("form");
        if (value != "" || value.match(/[^\s\t]/)) {
          illiJq(this).removeClass("input--error");
          illiJq(errorMessageBlock).addClass("hide");
          if (dataform == "day") {
            if (!checkDate(value)) {
              illiJq(this).addClass("input--error");
              illiJq(errorMessageBlock).removeClass("hide");
              illiJq(errorMessage).html("正しい年月日形式（例：2021/01/01）で入力してください");
              error = true;
            }
          } else if (dataform == "month") {
            if (!checkMonth(value)) {
              illiJq(this).addClass("input--error");
              illiJq(errorMessageBlock).removeClass("hide");
              illiJq(errorMessage).html("正しい年月形式（例：2021/01）で入力してください");
              error = true;
            }
          }
        }
      });
      

      if (error) {
        illiJq('#ajax-error-message').removeClass("hide");
        illiJq('#ajax-error-message').html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
        return false;
      }

      

      illiJq(this).addClass("btn-disable");
      illiJq(".loader").removeClass("hide");

      

      crosspointCheckCustomerApp();
      return true;
    });
  }

  

  if (location.pathname.match(/\/account\/addresses/)) {

    

    illiJq("#address_form_new-submit").click(function () {
      var ajaxErrorId = "#address_form_new-ajax-error-message";

      

      illiJq(".form__message").each(function () {
        illiJq(this).addClass("hide");
      });
      illiJq(".input--error").each(function () {
        illiJq(this).removeClass("input--error");
      });
      illiJq(ajaxErrorId).addClass("hide");

      

      illiJq(this).addClass("btn-disable");

      

      crosspointCheckAddressApp("#address_form_new", ajaxErrorId);
      return true;
    });

    

    illiJq(".address_form_edit-submit").click(function () {
      var form = illiJq(this).data("address");
      var formId = `#${form}`;
      var ajaxErrorId = `${formId}-ajax-error-message`;

      

      illiJq(".form__message").each(function () {
        illiJq(this).addClass("hide");
      });
      illiJq(".input--error").each(function () {
        illiJq(this).removeClass("input--error");
      });
      illiJq(ajaxErrorId).addClass("hide");

      

      illiJq(this).addClass("btn-disable");

      

      crosspointCheckAddressApp(formId, ajaxErrorId);
      return true;
    });
  }
});




function sysncCustomer(syncEmail) {
  var syncResult = illiJq.ajax({
    type: "POST",
    async: false,
    url: "/apps/crosspoint/login-sync",
    

    data: { email: syncEmail },
    success: function (data, dataType) {
      return data;
    },
    

    error: function () {
      return false;
    }
  }).responseText
}



function reservePwReset(recoberemail) {
  var reserveResult = illiJq.ajax({
    type: "POST",
    async: false,
    cache: false,
    url: "/apps/crosspoint/pw-reset-reserve",
    data: { recoberemail: recoberemail },
    success: function (data, dataType) {
      return data;
    },
    

    error: function () {
      return false;
    }
  }).responseText
}



function excutePwReset(form) {
  var hostUrl = '/apps/crosspoint/pw-reset-excute'
  illiJq.ajax({
    url: hostUrl,
    type: 'POST',
    async: false,
    cache: false,
    dataType: 'json',
    data: illiJq(form).serialize(),
    timeout: 3000,
  }).done(function (data) {
    if (data.result) {
      if (data.status == 'success') {
        return true;
      } else {
        return true;
      }
    }
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    return true;
  })
}



function getDisacountByCp() {
  var hostUrl = '/apps/crosspoint/get-coupon';
  var cart = getCart();
  var memberId = illiJq('#customerId').val();
  var shopIncludeTax = illiJq('#shopIncludeTax').val()
  var usePoint = illiJq("#usePoint").val();
  var apiResul = false;
  var ajaxResult = illiJq.ajax({
    url: hostUrl,
    type: 'POST',
    dataType: 'json',
    data: {
      cart: cart,
      memberId: memberId,
      shopIncludeTax: shopIncludeTax,
      usePoint: usePoint
    },
    timeout: 30000,
    async: false,
  }).done(function (data) {
    if (data.result) {
      if (data.status == 'success') {
                      if(data.result.discountCode){
                //$('#quantityDiscount').val(data.result.discountCode)
                setUseCoupon(data.result.discountCode)
              }else{
                 // $('#quantityDiscount').val(data.result)
                setUseCoupon(data.result)
                }
        apiResul = true;
      } else {
        openErrorMessageDialog(data.result);
        apiResul = false;
      }
    } else if (data.status == 'skip') {
      apiResul = true;
    }
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    openErrorMessageDialog("通信エラーが発生しました。時間をあけて再度お試しください");
  })
  return apiResul;
}



//Ajax @会員登録 or 会員更新バリデーション
function crosspointCheckCustomerApp(){
    //生年月日非活性解除
    illiJq('#year').prop("disabled", false);
    illiJq('#month').prop("disabled", false);
    illiJq('#date').prop("disabled", false);
    var postUrl = document.getElementById("crosspoint-post-url").value;
    //実行
  illiJq.ajax({
    url: postUrl,
    type: 'POST',
    dataType: 'json',
    data: illiJq('#RegisterForm').serialize(),
    timeout: 30000,
  })
    .then(
      function (res) {
        if (res.result) {
          if (res.status == 'success') {
            if (res.update) {
              document.getElementById("RegisterForm-cpToken").value = res.result;
              if(getParam('MEMBER_ID') && getParam('PIN_CD')){
              document.getElementById("RegisterForm-cpToken").value = res.result+'isFromApp';
              }
              crosspointUpdateCutomerApp(); 

            } else {
              if(getParam('MEMBER_ID') && getParam('PIN_CD')){
                document.getElementById("RegisterForm-cpToken").value = res.result+'isFromApp';
              }else{
                document.getElementById("RegisterForm-cpToken").value = res.result;
              }
             
              
              
              illiJq('#RegisterForm').submit(); 

            }
          } else {
            if (res.result == "shopifyApiError") { 

              illiJq('#ajax-error-message').removeClass("hide");
              illiJq('#ajax-error-message').html("通信エラーが発生しました。もう一度お試しください。");
            } else {
              setErrorMsg(res.result, crosspointCustomerFormId); 

              illiJq('#ajax-error-message').removeClass("hide");
              illiJq('#ajax-error-message').html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
            }
            setErrorMsg(res.result, crosspointCustomerFormId); 

            illiJq('#ajax-error-message').removeClass("hide");
            illiJq('#ajax-error-message').html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
            enableButton(); 


            if (res.update) {
              disableBirthDay(); 

            }
          }
        }
      },
        function(){
            illiJq('#ajax-error-message').removeClass("hide");
            illiJq('#ajax-error-message').html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
            enableButton(); //実行ボタン活性化
            if (postUrl == '/apps/crosspoint/check-update-member'){
                disableBirthDay(); //生年月日非活性
            }
        }
    );
}



function crosspointUpdateCutomerApp() {
  illiJq.ajax({
    url: '/apps/crosspoint/update-member',
    type: 'POST',
    dataType: 'json',
    data: {
      id: illiJq(`${crosspointCustomerFormId}-customerId`).val(),
      cpToken: illiJq(`${crosspointCustomerFormId}-cpToken`).val()
    },
    timeout: 30000,
  })
    .then(
      function (res) {
        if (res.status == 'success') {
          window.location.href = '/account'; 

        } else {
          illiJq('#ajax-error-message').removeClass("hide");
          illiJq('#ajax-error-message').html("会員情報の更新に失敗いたしました。申し訳ございませんが、時間をあけて再度お試しください。");
          enableButton(); 

          disableBirthDay(); 

        }
      },
      function () {
        illiJq('#ajax-error-message').removeClass("hide");
        illiJq('#ajax-error-message').html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
        enableButton(); 

        disableBirthDay(); 

      }
    );
}



function crosspointCheckAddressApp(formId, ajaxErrorId) {
  
  illiJq(window).on('beforeunload', function(e) {
    e.preventDefault();
    return '';
  });

  

  var addressForm = illiJq(formId);
  if (formId == "#address_form_new") { 

    var last_name = "#AddressLastNameNew";
    var first_name = "#AddressFirstNameNew";
    var company = "#AddressCompanyNew";
    var zip = "#AddressZipNew";
    var country = "#AddressCountryNew";
    var province = "#AddressProvinceNew";
    var city = "#AddressCityNew";
    var address1 = "#AddressAddress1New";
    var address2 = "#AddressAddress2New";
    var phone = "#AddressPhoneNew";
    var buttonId = "#address_form_new-submit";
  } else { 

    var inputId = formId.replace("#address_form_", "");
    var last_name = `#AddressLastName_${inputId}`;
    var first_name = `#AddressFirstName_${inputId}`;
    var company = `#AddressCompany_${inputId}`;
    var zip = `#AddressZip_${inputId}`;
    var country = `#AddressCountry_${inputId}`;
    var province = `#AddressProvince_${inputId}`;
    var city = `#AddressCity_${inputId}`;
    var address1 = `#AddressAddress1_${inputId}`;
    var address2 = `#AddressAddress2_${inputId}`;
    var phone = `#AddressPhone_${inputId}`;
    var buttonId = `#submit_${inputId}`;
  }
  

  illiJq(country).prop("disabled", false);
  

  illiJq.ajax({
    url: '/apps/crosspoint/check-update-address',
    type: 'POST',
    dataType: 'json',
    data: {
      address: {
        last_name: illiJq(last_name).val(),
        first_name: illiJq(first_name).val(),
        company: illiJq(company).val(),
        zip: illiJq(zip).val(),
        country: illiJq(country).val(),
        province: illiJq(province).val(),
        city: illiJq(city).val(),
        address1: illiJq(address1).val(),
        address2: illiJq(address2).val(),
        phone: illiJq(phone).val()
      }
    },
    timeout: 30000,
  })
    .then(
      function (res) {
        if (res.status == 'success') {
          addressForm.submit();
        } else {
          setErrorMsg(res.result, formId); 

          illiJq(ajaxErrorId).removeClass("hide");
          illiJq(ajaxErrorId).html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
          illiJq(buttonId).removeClass("btn-disable"); 

          illiJq(country).prop("disabled", true); 

          return false;
        }
      },
      function () {
        illiJq(ajaxErrorId).removeClass("hide");
        illiJq(ajaxErrorId).html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
        illiJq(buttonId).removeClass("btn-disable"); 

        illiJq(country).prop("disabled", true); 

        return false;
      }
    )
    .always(function () {
      
      illiJq(window).off('beforeunload');
    });
}



function getCart() {
  var result = illiJq.ajax({
    url: '/cart.js',
    dataType: 'json',
    async: false
  }).responseText;
  return result;
}



function isNumber(val) {
  var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
  return regexp.test(val);
}



function setErrorMsg(messages, formId) {
  for (key in messages) {
    

    if (formId == crosspointCustomerFormId) {
      var targetId = `${formId}-${key}`;
      

    } else if (formId == "#address_form_new") {
      var upperInitialKey = key.charAt(0).toUpperCase() + key.slice(1);
      var targetId = `#Address${upperInitialKey}New`;
      

    } else {
      var inputId = formId.replace("#address_form_", "");
      var upperInitialKey = key.charAt(0).toUpperCase() + key.slice(1);
      var targetId = `#Address${upperInitialKey}_${inputId}`;
    }
    if (key == "birthday") { 

      illiJq("#year").addClass("input--error");
      illiJq("#month").addClass("input--error");
      illiJq("#date").addClass("input--error");
    } else {
      illiJq(targetId).addClass("input--error");
    }
    illiJq(`${formId}-${key}-error`).removeClass("hide");
    illiJq(`${formId}-${key}-error-message`).html(messages[key]);
  }
}



function disableBirthDay() {
  var yearRegisterValue = illiJq(`${crosspointCustomerFormId}-birthday-update`).val();
  if (yearRegisterValue) {
    illiJq('#year').prop("disabled", true);
    illiJq('#month').prop("disabled", true);
    illiJq('#date').prop("disabled", true);
  }
}



function enableButton() {
  illiJq(`${crosspointCustomerFormId}-submit`).removeClass("btn-disable");
  illiJq(".loader").addClass("hide");
}



function checkDate(value) {
  

  if (!value.match(/^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/)) {
    return false;
  }
  

  var dateString = value.match(/^(\d+)\/(\d+)\/(\d+)$/);
  if (dateString) {
    var year = parseInt(dateString[1]);
    var month = parseInt(dateString[2]) - 1;
    var day = parseInt(dateString[3]);
    var collectDate = new Date(year, month, day);
    return (year == collectDate.getFullYear() && month == collectDate.getMonth() && day == collectDate.getDate());
  }
  return false;
}



function checkMonth(value) {
  

  if (!value.match(/^[0-9]{4}\/(0[1-9]|1[0-2])$/)) {
    return false;
  }
  

  var dateString = value.match(/^(\d+)\/(\d+)$/);
  if (dateString) {
    var year = parseInt(dateString[1]);
    var month = parseInt(dateString[2]) - 1;
    var collectDate = new Date(year, month);
    return (year == collectDate.getFullYear() && month == collectDate.getMonth());
  }
  return false;
}

function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function setUseCoupon(code){
  var ajaxResult = illiJq.ajax({
        url: '/discount/'+code,
        type:'GET',
        timeout:30000,
        async : false, 
    cache: false,
    }).done(function(data) {
apiResul = false;
    }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
        alert("通信エラーが発生しました。時間をあけて再度お試しください");
    })
    return apiResul;
}